import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useMsal } from '@azure/msal-react';
import { useDispatch } from 'react-redux';

import { authActions } from '../../../../redux/auth/actions';

export const LogoutButton = () => {
  const { t } = useTranslation();
  const { instance } = useMsal();
  const dispatch = useDispatch();

  const handleLogout = async () => {
    localStorage.removeItem('token');
    dispatch(authActions.logout());

    instance.logoutRedirect({});
  };

  return (
    <Button type='link' onClick={handleLogout}>
      {t('logout.logout')}
    </Button>
  );
};
